import React, { useState, useEffect, createContext, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import Login from './pages/Login';
import ContactUs from './pages/ContactUs';
import Pricing from './pages/Pricing';
import OwnerDashboard from './pages/OwnerDashboard';
import ResidentDashboard from './pages/ResidentDashboard';
import Communications from './pages/Communications';
import Properties from './pages/Properties';
import Maintenance from './pages/Maintenance';
import Accounting from './pages/Accounting';
import Leasing from './pages/Leasing';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import Calendar from './pages/Calendar';
import ResidentMessages from './pages/ResidentMessages';
import Residents from './pages/Residents';
import TenantLogin from './components/TenantLogin';
import { TenantUrlHandler } from './utils/tenantUrlHandler';

import './App.css';

const TenantContext = createContext();
export const useTenant = () => useContext(TenantContext);

function AppContent() {
  const location = useLocation();
  const [tenant, setTenant] = useState(null);
  const isAuthenticatedRoute = ['/owner-dashboard', '/resident-dashboard', '/communications', '/properties', '/maintenance', '/accounting', '/leasing', '/reports', '/settings', '/calendar', '/resident-messages', '/residents'].includes(location.pathname);

  return (
    <TenantContext.Provider value={tenant}>
      <div className="App">
        {!isAuthenticatedRoute && <Header />}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<TenantLogin setTenant={setTenant} />} />
          <Route path="/login/:tenantDomain" element={<Login />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/owner-dashboard" element={<OwnerDashboard />} />
          <Route path="/resident-dashboard" element={<ResidentDashboard />} />
          <Route path="/communications" element={<Communications />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/maintenance" element={<Maintenance />} />
          <Route path="/accounting" element={<Accounting />} />
          <Route path="/leasing" element={<Leasing />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/settings" element={<Settings tenant={tenant} />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/resident-messages" element={<ResidentMessages />} />
          <Route path="/residents" element={<Residents />} />
        </Routes>
      </div>
    </TenantContext.Provider>
  );
}

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AppContent />
    </Router>
  );
}

export default App;